<template>
  <el-form-item :label="i18nt('designer.setting.lazy')">
    <el-switch v-model="optionModel.lazy"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n";

  export default {
    name: "tree-lazy-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// tree-lazy-editor.vue?dfbf852e